import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, throwError } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { environment } from "../../../environments/environment";
import { catchError, map, retry } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ProjectResourcesService extends Subject<DataStateChangeEventArgs> {

  constructor(
    private http: HttpClient
  ) { 
    super();
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

   // Create projectResources
   createprojectResources(resourceDetails): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/projectResources`, resourceDetails).pipe(catchError(this.handleError));
  }

  createBulkProjectResources(resourceDetails): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/bulkProjectResources`, resourceDetails).pipe(catchError(this.handleError));
  }

   //Delete projectResources by Id Delete
   deleteProjectResources(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/projectResources/${id}`).pipe(catchError(this.handleError));
  }

   //Update projectResources by Id Put
   updateProjectResources(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/projectResources/${id}`, user).pipe(catchError(this.handleError));
  }

   //Get All projectResources
   getAllProjectResources(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectResources`).pipe(catchError(this.handleError));
  }

  //Get All projectResources by Id Get
  getAllProjectResourcesByProjectId(projectId): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectResources?projectId=${projectId}`).pipe(retry(2), catchError(this.handleError));
  }

  //Get All Active projectResources by Id Get
  getAllActiveProjectResourcesByProjectId(projectId): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectResources?projectId=${projectId}&active=true`).pipe(retry(2), catchError(this.handleError));
  }

  getProjectEstimations(projectId, year, month): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectEstimations?projectId=${projectId}&year=${year}&month=${month}`).pipe(retry(2), catchError(this.handleError));
  }

  getProjectTaskEstimations(projectId): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectTaskEstimations?projectId=${projectId}`).pipe(retry(2), catchError(this.handleError));
  }

  getProjectHoursBookingReport(startDate, endDate): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectHoursBookingReport?startDate=${startDate}&endDate=${endDate}`).pipe(retry(2), catchError(this.handleError));
  }

  getProjectEfficiencyReport(startDate, endDate): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectEfficiencyReport?startDate=${startDate}&endDate=${endDate}`).pipe(retry(2), catchError(this.handleError));
  }

  getProjectFreeResourceReport(startDate, endDate): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectFreeResourceReport?startDate=${startDate}&endDate=${endDate}`).pipe(retry(2), catchError(this.handleError));
  }



  // Project V2 Resources

   //Get All projectResources
   getAllProjectV2Resources(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectV2Resources`).pipe(catchError(this.handleError));
  }

   // Create projectResources
   createprojectV2Resources(resourceDetails): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/projectV2Resources`, resourceDetails).pipe(catchError(this.handleError));
  }

  createBulkProjectV2Resources(resourceDetails): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/bulkProjectV2Resources`, resourceDetails).pipe(catchError(this.handleError));
  }

   //Delete projectResources by Id Delete
   deleteProjectV2Resources(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/projectV2Resources/${id}`).pipe(catchError(this.handleError));
  }

   //Update projectResources by Id Put
   updateProjectV2Resources(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/projectV2Resources/${id}`, user).pipe(catchError(this.handleError));
  }

  //Get All projectResources by Id Get
  getAllProjectV2ResourcesByProjectId(projectV2Id): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectV2Resources?projectV2Id=${projectV2Id}`).pipe(retry(2), catchError(this.handleError));
  }

  getProjectFreeResourceReportV2(startDate, endDate): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/projectFreeResourceReportV2?startDate=${startDate}&endDate=${endDate}`).pipe(retry(2), catchError(this.handleError));
  }

}
